export const otherConfig = {
    other_encounter: {
        extractor: 'encounter',
        condition: [
            { field: 'resource', eq: 'Encounter' },
            //
        ],
    },
};
